// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__BvolP","item":"Category_item__25I45","active":"Category_active__263aE"};